import { Routes, Route } from 'react-router';

// Pages — match the original Next.js Pages Router structure 1:1
import Index from './pages/index';
import AboutUs from './pages/about-us';
import BecomePartner from './pages/become-partner';
import Calculator from './pages/calculator';
import ContactUs from './pages/contact-us';
import GetStarted from './pages/get-started';
import Posts from './pages/posts';
import WhyLinok from './pages/why-linok';
import BlogPost from './pages/blog/[...id]';
import NotFound from './pages/404';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/become-partner" element={<BecomePartner />} />
      <Route path="/calculator" element={<Calculator />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/get-started" element={<GetStarted />} />
      <Route path="/posts" element={<Posts />} />
      <Route path="/why-linok" element={<WhyLinok />} />
      <Route path="/blog/*" element={<BlogPost />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
